import CpdForm from '../../common/CpdForm';

export default function AddCpdForm() {
    return <CpdForm mode="Add" />;
}
